module.exports = __webpack_public_path__ + "img/download_explain_3.58fee64e.png";